import PhoneInput from "../PhoneInput";

const DriverMobileInput = ({
  inputSpecs,
  value,
  onChange,
  error,
}) => (
  <PhoneInput
    inputSpecs={inputSpecs}
    value={value}
    onChange={(newValue) => {
      onChange(newValue);
    }}
    error={error}
  />
);

export default DriverMobileInput;
